import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
// @flow
import React, { useContext } from 'react';
import { DataTable, SkeletonText } from 'carbon-components-react';
import { selectionColumnId } from '../common-column-ids';
import cx from 'classnames';
import { pkg, carbon } from '../../../settings';
import { InlineEditContext } from './addons/InlineEdit/InlineEditContext/InlineEditContext';
import { getCellIdAsObject } from './addons/InlineEdit/InlineEditContext/getCellIdAsObject';
var blockClass = "".concat(pkg.prefix, "--datagrid");
var TableRow = DataTable.TableRow,
    TableCell = DataTable.TableCell; // eslint-disable-next-line react/prop-types

var DatagridRow = function DatagridRow(datagridState) {
  var _cx;

  var row = datagridState.row;

  var _useContext = useContext(InlineEditContext),
      state = _useContext.state;

  var activeCellId = state.activeCellId;
  var activeCellObject = activeCellId && getCellIdAsObject(activeCellId);
  return /*#__PURE__*/React.createElement(TableRow, _extends({
    className: cx("".concat(blockClass, "__carbon-row"), (_cx = {}, _defineProperty(_cx, "".concat(blockClass, "__carbon-row-expanded"), row.isExpanded), _defineProperty(_cx, "".concat(carbon.prefix, "--data-table--selected"), row.isSelected), _defineProperty(_cx, "".concat(blockClass, "__carbon-row-hover-active"), activeCellObject && row.index === activeCellObject.row), _cx))
  }, row.getRowProps(), {
    key: row.id,
    onMouseEnter: function onMouseEnter(event) {
      var hoverRow = event.target.closest(".".concat(blockClass, "__carbon-row-expanded"));
      hoverRow === null || hoverRow === void 0 ? void 0 : hoverRow.classList.add("".concat(blockClass, "__carbon-row-expanded-hover-active"));
    },
    onMouseLeave: function onMouseLeave(event) {
      var hoverRow = event.target.closest(".".concat(blockClass, "__carbon-row-expanded"));
      hoverRow === null || hoverRow === void 0 ? void 0 : hoverRow.classList.remove("".concat(blockClass, "__carbon-row-expanded-hover-active"));
    }
  }), row.cells.map(function (cell) {
    var cellProps = cell.getCellProps();

    var children = cellProps.children,
        restProps = _objectWithoutProperties(cellProps, _excluded);

    var content = children || /*#__PURE__*/React.createElement(React.Fragment, null, !row.isSkeleton && cell.render('Cell'), row.isSkeleton && /*#__PURE__*/React.createElement(SkeletonText, null));

    if (cell && cell.column && cell.column.id === selectionColumnId) {
      // directly render component without the wrapping TableCell
      return cell.render('Cell', {
        key: cell.column.id
      });
    }

    return /*#__PURE__*/React.createElement(TableCell, _extends({
      className: "".concat(blockClass, "__cell")
    }, restProps, {
      key: cell.column.id
    }), content);
  }));
};

export default DatagridRow;